<template>
    <CompassModal
        v-model:visible="visible"
        :title="title"
        :primaryAction="primaryAction"
        :secondaryActions="secondaryActions"
        @closed="$emit('close')"
    >
        <p class="typographies-paragraph-medium-regular">
            {{ message }}
        </p>
    </CompassModal>
</template>

<script>
export default {
    emits: ['close'],
    data() {
        return {
            visible: false,
            title: this.$t.__('email.SettingsEmailsTemplatesWarningEditionModal.title'),
            message: this.$t.__('email.SettingsEmailsTemplatesWarningEditionModal.message'),
        };
    },
    computed: {
        primaryAction() {
            return {
                label: this.$t.__(
                    'email.SettingsEmailsTemplatesWarningEditionModal.btn_label_leave_without_save',
                ),
                type: 'primary-destructive',
                action: () => EventBus.emit('settingsEmailsTemplatesWarningEditionModal:leave'),
            };
        },
        secondaryActions() {
            return [
                {
                    label: this.$t.__('common.actions.cancel'),
                    type: 'secondary',
                    action: () => this.$emit('close'),
                },
            ];
        },
    },
    mounted() {
        this.visible = true;
    },
};
</script>
